import controller from './controller';
import template from './template.html';
import './style.less';

const controllerAs = 'blockCtrl';
const bindings = {
  certs: '<',
  profile: '<',
  regulator: '<',
  setCerts: '&',
  anchorScroll: '&',
  hideExport: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/report/reportNav/index.js